export default {
	d_redRubberBand: "This case has been red rubber-banded. Speak with the owner about the status of this case.",
	d_redRubberBand_portal: "Your account is currently overdue. Please contact us to make a payment as soon as possible.",

	d_warning: 'More than 80% of the available client funds have been depleted.  ' +
			   'Please be mindful of your time until the client trust fund is replenished.',
	d_warning_portal: 'More than 80% of the maximum has been used.',

	d_restricted: "This client has restricted funding.  Please be mindful of your time and work within the client's budget.",
	d_restricted_portal: "Your case has restricted funding.",

	d_lowTrust: "Please ask the client to replenish their trust balance.",
	d_lowTrust_portal: "Please replenish your trust balance",

	d_minimumBalance: (v) => `Trust below minimum balance of $${v.minimumBalance}`,
	d_minimumBalance_portal: (v) => `Your trust balance is below the minimum balance of $${v.minimumBalance}`,

	d_trustBalance: (v) => `Client has $${v.trustBalance} in their case and/or client trusts.`,
	d_trustBalance_portal: (v) => `You have $${v.trustBalance} in your case and/or client trusts.`,
}
